var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCellSignalX = function SvgIconCellSignalX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 6.75V4.664L3.164 19.25H17.75v-2a1 1 0 0 1 2 0v2.25A1.75 1.75 0 0 1 18 21.25H2.558a1.75 1.75 0 0 1-1.229-2.994L16.756 2.83a1.75 1.75 0 0 1 2.994 1.229V6.75a1 1 0 1 1-2 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.707 9.043a1 1 0 0 1 0 1.414L20.164 12l1.543 1.543a1 1 0 0 1-1.414 1.414l-1.543-1.543-1.543 1.543a1 1 0 0 1-1.414-1.414L17.336 12l-1.543-1.543a1 1 0 0 1 1.414-1.414l1.543 1.543 1.543-1.543a1 1 0 0 1 1.414 0"
  }))));
};
export default SvgIconCellSignalX;